import { useMutation } from "@tanstack/react-query";
import { sendProductReview } from "@src/entities/feedback/api/request/sendProductReview";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useSendProductReview = () => {
  const { showAlert } = useNotificationStore();

  return useMutation({
    mutationFn: sendProductReview,
    onSuccess: () => {
      showAlert("Спасибо! Ваш отзыв отправлен", "success");
    },
    onError: (error: Error) => {
      showAlert(error.message || "Не удалось отправить отзыв", "error");
    },
  });
};